import { createAction } from "redux-actions";

export const SIMULATOR_START_PUBLISH = "SIMULATOR_START_PUBLISH";
export const SIMULATOR_STOP_PUBLISH = "SIMULATOR_STOP_PUBLISH";

export const simulatorStartPublish = createAction(SIMULATOR_START_PUBLISH);
export const simulatorStopPublish = createAction(SIMULATOR_STOP_PUBLISH);
